import { UIBox } from '@/components/ui/Box';
import styled from 'styled-components';

export const UIListWrapper = styled(UIBox)`
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
  z-index: 0;
`;
